import type { TOC } from '@ember/component/template-only';
import Table from 'tio-ui/components/table';
import { PhInfo } from 'ember-phosphor-icons';
import { t } from 'ember-intl';
import safeFormatDate from 'tio-common/helpers/safe-format-date';
import type DependentModel from 'tio-common/models/dependent';

interface FamilyMembersListSignature {
  Args: {
    dependents: DependentModel[];
    companyName: string;
  };
}

const FamilyMembersList: TOC<FamilyMembersListSignature> = <template>
  {{! Info box from mockup }}
  <div class="flex gap-3 p-4 bg-blue-50 border border-blue-200 rounded mb-4">
    <PhInfo @size="20" class="text-blue-600 flex-shrink-0 mt-0.5" />
    <div class="text-sm text-gray-700">
      <strong>{{t "profile.family.info_title"}}</strong>
      <p class="mt-1">
        {{t "profile.family.info_description" employer=@companyName}}
      </p>
    </div>
  </div>

  {{#if @dependents.length}}
    <Table>
      <:thead as |head|>
        <head.tr>
          <head.th>{{t "profile.family.name_label"}}</head.th>
          <head.th>{{t "profile.family.invited_label"}}</head.th>
          <head.th>{{t "profile.family.enrolled_label"}}</head.th>
          <head.th>{{t "profile.family.relationship_label"}}</head.th>
        </head.tr>
      </:thead>
      <:tbody as |body|>
        {{#each @dependents as |dependent|}}
          <body.tr>
            <body.td>
              <div class="font-semibold text-gray-900">{{dependent.fullName}}</div>
            </body.td>
            <body.td>
              {{safeFormatDate dependent.createdAt}}
            </body.td>
            <body.td>
              {{safeFormatDate dependent.enrolledDate}}
            </body.td>
            <body.td>
              {{dependent.relationshipLabel}}
            </body.td>
          </body.tr>
        {{/each}}
      </:tbody>
    </Table>
  {{else}}
    <div class="text-gray-500 text-center py-8">
      {{t "profile.family.empty_state"}}
    </div>
  {{/if}}
</template>;

export default FamilyMembersList;
